import { EEvent } from '@pes-ui/utils/lib/constants';
import { sendEvent } from '../../utils';
import { getComparatorThreshold, getStorageComparatorName, COMPARATOR_LOCALE } from './utils';
const isApc = Boolean(window.isApc);
export const MAX_COMPARATOR_ITEMS = getComparatorThreshold();
const BACK_TO_RESULTS_LINK = 'pesBackLink';
const STORAGE_COMPARATOR_NAME = getStorageComparatorName();
const PRODUCT_IDS_SEPARATOR = ',';
class Comparator {
  constructor() {
    this.handleCompareControlClick = (event) => {
      const productId = typeof event.detail === 'string' ? event.detail : event.detail.repositoryId;
      if (this.has(productId)) {
        this.remove(productId);
      }
      else if (!this.isFull()) {
        this.add(productId);
      }
      else {
        return;
      }
      this.notifySubscribers();
    };
    this.handleStorageChange = (event) => {
      if (event.key === STORAGE_COMPARATOR_NAME) {
        this.notifySubscribers();
      }
    };
    this.setListeners();
    if (!isApc) {
      this.setBackLink();
    }
  }
  setListeners() {
    window.addEventListener(EEvent.COMPARE_CONTROL_CLICK, this.handleCompareControlClick);
    window.addEventListener('storage', this.handleStorageChange);
  }
  setBackLink() {
    window.localStorage.setItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`, window.location.href);
  }
  getBackLink() {
    return window.localStorage.getItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`) || '';
  }
  getStoredProductIds() {
    var _a;
    const serializedList = (_a = localStorage.getItem(STORAGE_COMPARATOR_NAME)) !== null && _a !== void 0 ? _a : '';
    if (!isApc) {
      return serializedList.split(PRODUCT_IDS_SEPARATOR).filter(Boolean);
    }
    let result = [];
    try {
      result = JSON.parse(serializedList);
    }
    finally {
      return result;
    }
  }
  store(productIds) {
    let serializedList;
    if (!isApc) {
      serializedList = productIds.join(PRODUCT_IDS_SEPARATOR);
    }
    else {
      serializedList = JSON.stringify(productIds);
    }
    localStorage.setItem(STORAGE_COMPARATOR_NAME, serializedList);
  }
  has(productId) {
    return this.getStoredProductIds().includes(productId);
  }
  add(productId) {
    const productIds = [...this.getStoredProductIds(), productId];
    this.store(productIds);
  }
  remove(productId) {
    const productIds = this.getStoredProductIds();
    this.store(productIds.filter((id) => productId !== id));
  }
  isFull() {
    if (MAX_COMPARATOR_ITEMS) {
      return this.getStoredProductIds().length >= MAX_COMPARATOR_ITEMS;
    }
    return false;
  }
  get value() {
    return {
      list: this.getStoredProductIds(),
      isFull: this.isFull(),
      productProp: 'repositoryId',
    };
  }
  notifySubscribers() {
    sendEvent(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.value);
  }
  removeAll() {
    localStorage.removeItem(STORAGE_COMPARATOR_NAME);
    this.notifySubscribers();
  }
}
export const comparator = new Comparator();
